var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "mounting-portal",
        {
          attrs: {
            name: "modpack-search",
            "mount-to": "#modpack",
            prepend: "",
          },
        },
        [
          _c(
            "div",
            { staticClass: "modpack" },
            [
              _c("h2", [
                _vm._v(_vm._s(_vm.i18n.t("landingpage:modpack.title"))),
              ]),
              _vm._v(" "),
              _c("p", [
                _vm._v(_vm._s(_vm.i18n.t("landingpage:modpack.description"))),
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "modpack__inner" },
                [
                  _c("base-text-input", {
                    ref: "SearchInput",
                    attrs: {
                      icon: ["fas", "search"],
                      "change-debounce": 250,
                      value: _vm.state.phrase,
                      placeholder: _vm.i18n.t(
                        "landingpage:mods.search.placeholder"
                      ),
                      disabled:
                        _vm.state.isModsLoading || _vm.state.isModsFailure,
                    },
                    on: { change: _vm.setPhrase },
                    scopedSlots: _vm._u([
                      {
                        key: "content",
                        fn: function () {
                          return [
                            _c(
                              "div",
                              { staticClass: "modpack--input-loader-wrapper" },
                              [
                                _vm.state.phrase.length > 0
                                  ? _c("font-awesome-icon", {
                                      staticClass:
                                        "modpack--input-loader-clear",
                                      attrs: { icon: ["far", "times"] },
                                      on: {
                                        click: function ($event) {
                                          return _vm.clearSearchInput()
                                        },
                                      },
                                    })
                                  : _vm.state.isModsLoading
                                  ? _c("font-awesome-icon", {
                                      attrs: {
                                        icon: ["fas", "spinner"],
                                        spin: "",
                                      },
                                    })
                                  : _vm._e(),
                              ],
                              1
                            ),
                          ]
                        },
                        proxy: true,
                      },
                    ]),
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _vm.state.isModsFailure
                ? [
                    _vm._v(
                      "\n        " +
                        _vm._s(
                          _vm.i18n.t("landingpage:modpack.api_unavailable")
                        ) +
                        "\n      "
                    ),
                  ]
                : _vm.state.isModsReady && _vm.state.phrase.length
                ? [
                    _vm.state.filteredMods && _vm.state.filteredMods.length
                      ? _c("base-modpack-list", {
                          on: {
                            "on-mod-selected": function ($event) {
                              _vm.state.selectedMod = $event
                            },
                          },
                          model: {
                            value: _vm.state.filteredMods,
                            callback: function ($$v) {
                              _vm.$set(_vm.state, "filteredMods", $$v)
                            },
                            expression: "state.filteredMods",
                          },
                        })
                      : _c("div", { staticClass: "modpack--not-found" }, [
                          _vm._v(
                            "\n          " +
                              _vm._s(_vm.i18n.t("landingpage:mods.not_found")) +
                              "\n        "
                          ),
                        ]),
                  ]
                : _vm.state.isModsReady &&
                  _vm.state.popularMods &&
                  _vm.state.popularMods.length
                ? [
                    _c("base-modpack-list", {
                      on: {
                        "on-mod-selected": function ($event) {
                          _vm.state.selectedMod = $event
                        },
                      },
                      model: {
                        value: _vm.state.popularMods,
                        callback: function ($$v) {
                          _vm.$set(_vm.state, "popularMods", $$v)
                        },
                        expression: "state.popularMods",
                      },
                    }),
                  ]
                : !_vm.state.hasLoadedMods
                ? [
                    _c("base-modpack-list", {
                      attrs: { disabled: true },
                      model: {
                        value: _vm.state.mockedMods,
                        callback: function ($$v) {
                          _vm.$set(_vm.state, "mockedMods", $$v)
                        },
                        expression: "state.mockedMods",
                      },
                    }),
                  ]
                : _vm._e(),
            ],
            2
          ),
        ]
      ),
      _vm._v(" "),
      _vm.state.selectedMod
        ? _c("base-modpack-modal", {
            on: {
              "on-cancel-click": function ($event) {
                _vm.state.selectedMod = null
              },
            },
            model: {
              value: _vm.state.selectedMod,
              callback: function ($$v) {
                _vm.$set(_vm.state, "selectedMod", $$v)
              },
              expression: "state.selectedMod",
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }